import React, { useState, useEffect, useRef } from 'react'
// import { useFormik } from 'formik'
// import * as Yup from 'yup'
import ReportsService from '../../../../../services/reports.service'

import { Modal, Rte, MuiButton } from '../../../../../components'
// import { IconButton } from '@mui/material'
import { IconEdit } from '../../../../../assets/images/icons'
import { rteRemovingStyleFromTable } from '../../../../../util'

import { LoginButton, Title, Wrapper, RteWrapper, RtePreviewCss } from './style'

const AddEditTable = (props) => {
  const { settings, InsightsElementId, data, onSuccess, onClose, title, type } = props
  const [anchorElUser, setAnchorElUser] = useState(null)
  const [showEditHeaderModal, setShowEditHeaderModal] = useState(false)

  const form = useRef()
  const [loader, setLoader] = useState(false)
  const [columnValue, setColumnValue] = useState()

  const handleOnEditHeader = () => {
    setAnchorElUser(null)
    setShowEditHeaderModal((prev) => !prev)
    onClose()
  }

  const onSubmit = (e) => {
    e.preventDefault()

    const customTableRow = {
      customRowColumns: settings.data.map((d, i) => {
        return {
          CustomRowColumn: {
            // CustomColumnName: d.CustomColumnName,
            InsightsElementId: InsightsElementId,
            CustomRowId: type === 'add' ? '00000000-0000-0000-0000-000000000000' : data.rowId,
            CustomColumnId: d.CustomColumnId,
            CustomColumnValue: columnValue[i]
              ? encodeURIComponent(rteRemovingStyleFromTable(columnValue[i]))
              : null, // Hindi conversion
          },
        }
      }),
      delete: false,
    }

    setLoader(true)
    ReportsService.reportSetCustomTableRowApi(customTableRow)
      .then((resp) => {
        setLoader(false)
        setShowEditHeaderModal(false)
        onSuccess()
      })
      .catch((error) => {
        setLoader(false)
        const resMessage = error
        console.log('ERROR : ', resMessage)
        // enqueueSnackbar(resMessage, { variant: 'error' })
      })
  }

  const updateColumnValueFunc = (value, index) => {
    const array = columnValue
    array[index] = value
    setColumnValue(array)
  }

  useEffect(() => {
    if (type === 'edit') {
      const columnArray = [
        data.topic,
        data.column1,
        data.column2,
        data.column3,
        data.column4,
        data.column5,
        data.column6,
      ]
      setColumnValue(columnArray)
    } else if (type === 'add') {
      setColumnValue(Array(settings.data.length).fill('<p> </p>'))
    }
  }, [data])

  return (
    <>
      <Modal title={`${type} Item`} showClose={true} onClose={handleOnEditHeader} styleType="themeV2">
        <Wrapper>
          <form ref={form}>
            {/* <Title variant='body1'>{type} Item</Title> */}

            <RteWrapper>
              {columnValue &&
                type === 'add' &&
                settings.data.map((d, i) => {
                  const customToolbar =
                    i === 0
                      ? 'bold | undo redo '
                      : 'h4 h5 | bold italic underline strikethrough link | hr | bullist | undo redo '
                  return (
                    <Rte
                      key={'rte_' + i}
                      title={d.CustomColumnName}
                      value={columnValue[i]}
                      onChange={(e) => updateColumnValueFunc(e, i)}
                      height={200}
                      customToolbar={customToolbar}
                      content_style={RtePreviewCss}
                    />
                  )
                })}
              {columnValue &&
                type === 'edit' &&
                settings.data.map((d, i) => {
                  const customToolbar =
                    i === 0
                      ? 'bold | undo redo '
                      : 'h4 h5 | bold italic underline strikethrough link | hr | bullist | undo redo '
                  return (
                    <Rte
                      key={'rte_' + i}
                      title={d.CustomColumnName}
                      value={columnValue[i]}
                      onChange={(e) => updateColumnValueFunc(e, i)}
                      height={200}
                      customToolbar={customToolbar}
                      content_style={RtePreviewCss}
                    />
                  )
                })}
            </RteWrapper>

            <LoginButton
              color='primary'
              variant='contained'
              type='submit'
              onClick={onSubmit}
              disabled={loader || false}
            >
              Submit
            </LoginButton>
          </form>
        </Wrapper>
      </Modal>
    </>
  )
}

export default AddEditTable
